
import { defineComponent } from "vue";

export default defineComponent({
  name: "LoadingSpinner",
  props: {
    cls: {
      type: String,
      required: false,
    },
    size: {
      type: String,
      required: false,
      default: "h-10 w-10",
    },
    color: {
      type: String,
      required: false,
      default: "text-yellow-700",
    },
  },
});
